import notify from "devextreme/ui/notify";
import ExcelJS from "exceljs";
import Cookies from "js-cookie";
import i18n from "../../src/i18n";
import exportDataGrid, { saveAsCustom } from "./dxExportGrid";
import { getStringMask } from "./getStringMask";
import { getUuidv4 } from "./getUuidv4";
import { defaultFilterOperationsNumeric } from "./utilsConst";

/**
 * @deprecated Use getErrorList2 instead
 */
export function getErrorList(objString: string, newLineChar: string = "\n", config: any = {}): string {
  if (objString === null || objString === undefined) return "";
  let data;
  const showCount = config?.showCount ?? false;
  newLineChar = config?.newLineChar ?? newLineChar;

  try {
    data = JSON.parse(objString);
  } catch (e) {
    return objString;
  }
  let count = 1;
  let result = "";

  for (const [key, value] of Object.entries<any>(data)) {
    console.log("🚀 ~ file: utils.js ~ line 7 ~ GetErrorList ~ key", key);
    result += showCount ? `${count}. ${value.Errors[0].ErrorMessage}.${newLineChar}` : `${value.Errors[0].ErrorMessage}.${newLineChar}`;
    count++;
  }
  return result;
}

export function getErrorList2(objString: string, config: any = {}): string {
  if (objString === null || objString === undefined) return "";

  let data;
  const showCount = config?.showCount ?? false;
  const newLineChar = config?.newLineChar ?? "</br>";
  const useObjectEntries = config?.useObjectEntries ?? false;
  const showMultipleErrors = config?.showMultipleErrors ?? false;

  try {
    data = JSON.parse(objString);
  } catch (e) {
    return objString;
  }

  let count = 1;
  let result = "";

  if (useObjectEntries) {
    for (const [, value] of Object.entries<any>(data)) {
      if (showMultipleErrors) {
        const messages = getErrorMessages(value.Errors);
        console.log(value.Errors, messages);
        result += messages;
      } else {
        const message = `${value.Errors[0].ErrorMessage} ${newLineChar}`;
        result += showCount ? `${count}. ${message}` : message;
      }

      count++;
    }
  } else {
    for (let field in data) {
      const errores = data[field];

      // eslint-disable-next-line no-loop-func
      errores.forEach((error: string) => {
        result += showCount ? `${count}. ${error} ${newLineChar}` : `${error} ${newLineChar}`;
        count = count + 1;
      });
    }
  }

  return result;
}

function getErrorMessages(errors: any = []): string {
  let messages = "";
  const newLineChar = "</br>";

  errors.forEach((error: any) => {
    messages += `${error.ErrorMessage} ${newLineChar}`;
  });

  return messages;
}

export function formatPedimento(value: number): string {
  if (value <= 0) return "00-00-0000-0000000";
  let pedimento = value.toString();
  pedimento = ("000000000000000" + pedimento).slice(-15);
  return `${pedimento.substring(0, 2)}-${pedimento.substring(2, 4)}-${pedimento.substring(4, 8)}-${pedimento.substring(8)}`;
}

export function formatPedimentoEmpty(value: number): string {
  if (value <= 0) return "";
  let pedimento = value.toString();
  pedimento = ("000000000000000" + pedimento).slice(-15);
  return `${pedimento.substring(0, 2)}-${pedimento.substring(2, 4)}-${pedimento.substring(4, 8)}-${pedimento.substring(8)}`;
}

export function formatFraccion(value: number): string {
  if (value <= 0) return "00000000";
  let fraccion = value.toString();
  if (fraccion.length < 8) fraccion = fraccion.padStart(8, "0");
  return fraccion;
}

/**
 * @deprecated Use formatDate2 instead
 */
export function formatDate(value: Date, englishLang: boolean = false): string {
  if (value.getFullYear() < 1900) return dateFormatter2(DATE_1900, "yyyy-mm-ddT", "dd/MMM/yyyy");

  let lang = getValidLanguage();

  if (englishLang) {
    lang = "en-US";
  }
  const timeZone = "UTC";
  const dateJs = new Date(value);
  const day = dateJs.toLocaleString(lang || "default", { day: "2-digit", timeZone: timeZone });
  const year = dateJs.toLocaleString(lang || "default", { year: "numeric", timeZone: timeZone });
  const month2Digit = dateJs.toLocaleString(lang || "default", { month: "2-digit", timeZone: timeZone });
  const formatDate = `${year}-${month2Digit}-${day}`;
  return dateFormatter2(formatDate, "yyyy-mm-dd", "dd/MMM/yyyy");
}

export function formatDate2(value: Date, config: any = false): string {
  if (value.getFullYear() < 1900) return dateFormatter2(DATE_1900, "yyyy-mm-ddT", "dd/MMM/yyyy");

  let lang = getValidLanguage();

  if (config?.englishLang) {
    lang = "en-US";
  }
  const timeZone = "UTC";
  const dateJs = new Date(value);
  const day = dateJs.toLocaleString(lang || "default", { day: "2-digit", timeZone: timeZone });
  const year = dateJs.toLocaleString(lang || "default", { year: "numeric", timeZone: timeZone });
  const month2Digit = dateJs.toLocaleString(lang || "default", { month: "2-digit", timeZone: timeZone });
  const formatDate = `${year}-${month2Digit}-${day}`;
  return dateFormatter2(formatDate, "yyyy-mm-dd", config?.outputFormat);
}

/**
 * @deprecated Use currentDate2 instead
 */
export function dateFormatter(data: string, incommingFormat: string, outputFormat: string, englishLang: boolean = false): string {
  let lang = getValidLanguage();

  if (englishLang) {
    lang = "en-US";
  }

  const timeZone = "UTC";
  let formattedDate = "";

  try {
    switch (incommingFormat) {
      case "yyyy-mm-ddT":
      case "yyyy-mm-dd": {
        data = data.includes("T") ? data.split("T")[0] : data;
        const dateJs = new Date(data);
        const day = dateJs.toLocaleString(lang || "default", { day: "2-digit", timeZone: timeZone });
        const year = dateJs.toLocaleString(lang || "default", { year: "numeric", timeZone: timeZone });
        const month2Digit = dateJs.toLocaleString(lang || "default", { month: "2-digit", timeZone: timeZone });
        const formatDate = `${year}-${month2Digit}-${day}`;

        switch (outputFormat) {
          case "dd/MMM/yyyy":
            {
              let month = dateJs.toLocaleString(lang || "default", { month: "short", timeZone: timeZone });
              const month_ = month.charAt(0).toUpperCase() + month.slice(1, 3);
              formattedDate = `${day}/${month_}/${year}`;
            }
            break;
          case "yyyy-mm-dd":
            formattedDate = formatDate;
            break;
          case "yyyy-mm-d":
            {
              const day_ = dateJs.toLocaleString(lang || "default", { day: "numeric", timeZone: timeZone });
              formattedDate = `${year}-${month2Digit}-${day_}`;
            }
            break;
          case "yyyy-mm-ddT":
            formattedDate = `${formatDate}T00:00:00`;
            break;
          case "yyyy-mm-ddTZ":
            formattedDate = `${formatDate}T00:00:00Z`;
            break;
          case "yyyyMMdd":
            formattedDate = `${year}${month2Digit}${day}`;
            break;
          default:
            console.error("ERROR useDateFormatter: Requiere outputFormat válido.");
            break;
        }
        break;
      }
      case "dd/MMM/yyyy":
        switch (outputFormat) {
          case "yyyy-mm-ddT":
            {
              let date = data.split("/");
              const monthEsp = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sept", "oct", "nov", "dic"];
              const monthEng = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
              const numberMonth = lang === "es-MX" ? monthEsp.indexOf(date[1].toLowerCase()) + 1 : monthEng.indexOf(date[1].toLowerCase()) + 1;
              formattedDate = `${date[2]}-${numberMonth}-${date[0]}T00:00:00`;
            }
            break;

          case "yyyy-mm-dd":
            {
              let date = data.split("/");
              const monthEsp = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
              const monthEng = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
              const numberMonth = lang === "es-MX" ? monthEsp.indexOf(date[1].toLowerCase()) + 1 : monthEng.indexOf(date[1].toLowerCase()) + 1;
              formattedDate = `${date[2]}-${numberMonth}-${date[0]}`;
            }
            break;
          default:
            console.error("ERROR useDateFormatter: Requiere outputFormat válido.");
            break;
        }
        break;
      case "yyyy-mm-ddTZ":
        if (outputFormat === "yyyy-mm-ddT") {
          if (data.length > 0) {
            formattedDate = data.slice(0, -1);
          }
        } else {
          console.error("ERROR useDateFormatter: Requiere outputFormat válido.");
        }
        break;
      default:
        console.error("ERROR useDateFormatter: Requiere incommingFormat válido.");
        break;
    }
  } catch (error) {
    formattedDate = "";
    console.log("ERROR useDateFormatter:", error);
  }

  return formattedDate;
}

export function dateFormatter2(data: string, incommingFormat: string, outputFormat: string, englishLang: boolean = false, addDays: number = 0, addMonths: number = 0): string {
  let lang = getValidLanguage();

  if (englishLang) {
    lang = "en-US";
  }

  const timeZone = "UTC";
  let formattedDate = "";
  try {
    switch (incommingFormat) {
      case "yyyy-mm-ddT":
      case "yyyy-mm-dd": {
        data = data.includes("T") ? data.split("T")[0] : data;
        const dateJs = new Date(data);
        if (addDays > 0) {
          dateJs.setUTCDate(dateJs.getUTCDate() + addDays);
        }

        if (addMonths > 0) {
          dateJs.setUTCMonth(dateJs.getUTCMonth() + addMonths);
        }

        const day = dateJs.toLocaleString(lang || "default", { day: "2-digit", timeZone: timeZone });
        const year = dateJs.toLocaleString(lang || "default", { year: "numeric", timeZone: timeZone });
        const month2Digit = dateJs.toLocaleString(lang || "default", { month: "2-digit", timeZone: timeZone });
        const formatDate = `${year}-${month2Digit}-${day}`;

        switch (outputFormat) {
          case "dd/MMM/yyyy":
            {
              let month = dateJs.toLocaleString(lang || "default", { month: "short", timeZone: timeZone });
              const month_ = month.charAt(0).toUpperCase() + month.slice(1, 3);
              formattedDate = `${day}/${month_}/${year}`;
            }
            break;
          case "yyyy-mm-dd":
            formattedDate = formatDate;
            break;
          case "yyyy-mm-d":
            {
              const day_ = dateJs.toLocaleString(lang || "default", { day: "numeric", timeZone: timeZone });
              formattedDate = `${year}-${month2Digit}-${day_}`;
            }
            break;
          case "yyyy-mm-ddT":
            formattedDate = `${formatDate}T00:00:00`;
            break;
          case "yyyy-mm-ddTZ":
            formattedDate = `${formatDate}T00:00:00Z`;
            break;
          case "yyyyMMdd":
            formattedDate = `${year}${month2Digit}${day}`;
            break;
          default:
            console.error("ERROR useDateFormatter: Requiere outputFormat válido.");
            break;
        }
        break;
      }
      case "yyyy-mm-ddTZ":
        if (outputFormat === "yyyy-mm-ddT") {
          if (data.length > 0) {
            formattedDate = data.slice(0, -1);
          }
        } else {
          console.error("ERROR useDateFormatter: Requiere outputFormat válido.");
        }
        break;
      default:
        console.error("ERROR useDateFormatter2: Requiere incommingFormat válido.");
        break;
    }
  } catch (error) {
    formattedDate = "";
    console.log("ERROR Try-Catch useDateFormatter2:", error);
  }

  return formattedDate;
}

/**
 * @deprecated Use currentDate2 instead
 */
export function currentDate(outputFormat: string): string {
  let lang = getValidLanguage();
  const dateJs = new Date();
  let formattedDate = "";

  if (!outputFormat) {
    outputFormat = "yyyy-mm-ddT";
  }

  try {
    const day = dateJs.toLocaleString(lang || "default", { day: "2-digit" });
    const year = dateJs.toLocaleString(lang || "default", { year: "numeric" });
    const month2Digit = dateJs.toLocaleString(lang || "default", { month: "2-digit" });
    const hour = dateJs.toLocaleString(lang || "default", { hour: "2-digit" });
    const minute = dateJs.toLocaleString(lang || "default", { minute: "2-digit" });
    const second = dateJs.toLocaleString(lang || "default", { second: "2-digit" });
    const formatDate = `${year}-${month2Digit}-${day}`;

    switch (outputFormat) {
      case "dd/MMM/yyyy":
        {
          let month = dateJs.toLocaleString(lang || "default", { month: "short" });
          const month_ = month.charAt(0).toUpperCase() + month.slice(1, 3);
          formattedDate = `${day}/${month_}/${year}`;
        }
        break;
      case "yyyy-mm-dd":
        formattedDate = formatDate;
        break;
      case "yyyy-mm-dT":
      case "yyyy-mm-ddT":
        formattedDate = `${formatDate}T00:00:00`;
        break;
      case "yyyy-mm-ddTZ":
        formattedDate = `${formatDate}T00:00:00Z`;
        break;
      case "long": {
        const weekday = dateJs.toLocaleString(lang || "default", { weekday: "long" });
        const monthLong = dateJs.toLocaleString(lang || "default", { month: "long" });
        if (lang === "es-MX") formattedDate = `${weekday}, ${day} de ${monthLong} de ${year}`;
        else formattedDate = `${weekday}, ${monthLong} ${day}, ${year}`;
        break;
      }
      case "time": {
        const hora = dateJs.toLocaleTimeString(lang || "default", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
        formattedDate = `${formatDate} ${hora}`;
        break;
      }
      case "yyyyMMddHHmmss":
        formattedDate = `${year}${month2Digit}${day}${hour}${minute}${second}`;
        break;
      default:
        console.error("ERROR currentDate: Requiere outputFormat válido.");
        break;
    }
  } catch (error) {
    formattedDate = "";
    console.log("ERROR currentDate: ", error);
  }
  return formattedDate;
}

export function currentDate2({ outputFormat = "", addDays = 0, addHours = 0 }: { outputFormat: string; addDays: number; addHours: number }): any {
  const lang = getValidLanguage();
  const langToLocale = lang ?? "default";
  const dateJs = new Date();
  let formattedDate = "";

  if (addDays !== 0) {
    dateJs.setDate(dateJs.getDate() + addDays);
  }

  if (addHours !== 0) {
    dateJs.setHours(dateJs.getHours() + addHours);
  }

  if (!outputFormat) {
    outputFormat = "yyyy-mm-ddT";
  }

  try {
    const day = dateJs.toLocaleString(langToLocale, { day: "2-digit" });
    const year = dateJs.toLocaleString(langToLocale, { year: "numeric" });
    const month2Digit = dateJs.toLocaleString(langToLocale, { month: "2-digit" });
    const hour = dateJs.toLocaleString(langToLocale, { hour: "2-digit", hour12: false });
    const minute = dateJs.toLocaleString(langToLocale, { minute: "2-digit" });
    const second = dateJs.toLocaleString(langToLocale, { second: "2-digit" });
    const baseDate = `${year}-${month2Digit}-${day}`;

    switch (outputFormat) {
      case "dd/MMM/yyyy": //-> 28/Dic/2023 || 28/Dec/2023
        {
          const month = dateJs.toLocaleString(langToLocale, { month: "short" });
          const month_ = month.charAt(0).toUpperCase() + month.slice(1, 3);
          formattedDate = `${day}/${month_}/${year}`;
        }
        break;
      case "yyyy-mm-dd": //-> 2023-12-28
        formattedDate = baseDate;
        break;
      case "yyyy-mm-dT": //-> 2023-12-28T00:00:00
      case "yyyy-mm-ddT": //-> 2023-12-28T00:00:00
        formattedDate = `${baseDate}T00:00:00`;
        break;
      case "yyyy-mm-ddTZ": //-> 2023-12-28T00:00:00Z
        formattedDate = `${baseDate}T00:00:00Z`;
        break;
      case "long": //-> jueves, diciembre 28, 2023 || Thursday, December 28, 2023
        {
          const weekday = dateJs.toLocaleString(langToLocale, { weekday: "long" });
          const monthLong = dateJs.toLocaleString(langToLocale, { month: "long" });
          if (lang === "es-MX") formattedDate = `${weekday}, ${day} de ${monthLong} de ${year}`;
          else formattedDate = `${weekday}, ${monthLong} ${day}, ${year}`;
        }
        break;
      case "time": //-> 2023-12-28 09:35:29
        {
          const hora = dateJs.toLocaleTimeString(langToLocale, { hour: "2-digit", minute: "2-digit", second: "2-digit" });
          formattedDate = `${baseDate} ${hora}`;
        }
        break;
      case "time-24-hrs": //-> 2023-12-28 09:35:29
        {
          const hora = dateJs.toLocaleTimeString(langToLocale, { hour12: false, hour: "2-digit", minute: "2-digit", second: "2-digit" });
          formattedDate = `${baseDate} ${hora}`;
        }
        break;
      case "yyyyMMddHHmmss": //-> 20231228093529
        formattedDate = `${year}${month2Digit}${day}${hour}${minute}${second}`;
        break;
      case "yyyyMMddhhmm":
        formattedDate = `${year}${month2Digit}${day}${hour}${minute}`;
        break;
      case "yyyyMMdd": // => 20231228
        formattedDate = `${year}${month2Digit}${day}`;
        break;
      case "HHmmss": {
        //-> 162501
        const hour24 = dateJs.toLocaleString(langToLocale, { hour: "2-digit", hour12: false });
        formattedDate = `${hour24}${minute}${second}`;
        break;
      }
      default:
        console.error("ERROR currentDate2: Requiere outputFormat válido.");
        break;
    }
  } catch (error) {
    formattedDate = "";
    console.log("ERROR currentDate2: ", error);
  }

  return formattedDate;
}

export function createDate(outputFormat: string, year: number, monthIndex: number, date: number): string {
  const lang = getValidLanguage();

  if (!year) {
    console.error("ERROR createDate: Requiere: year.");
    return "";
  }

  if (monthIndex < 0 || monthIndex > 11) {
    console.error("ERROR createDate: Requiere: monthIndex. 0-11");
    return "";
  }

  if (!date) {
    console.error("ERROR createDate: Requiere: date. 1-31.");
    return "";
  }

  const dateJs = new Date(year, monthIndex, date);
  let formattedDate = "";

  if (!outputFormat) {
    outputFormat = "yyyy-mm-ddT";
  }

  try {
    const day = dateJs.toLocaleString(lang || "default", { day: "2-digit" });
    const year = dateJs.toLocaleString(lang || "default", { year: "numeric" });
    const month2Digit = dateJs.toLocaleString(lang || "default", { month: "2-digit" });
    const formatDate = `${year}-${month2Digit}-${day}`;

    switch (outputFormat) {
      case "dd/MMM/yyyy":
        {
          let month = dateJs.toLocaleString(lang || "default", { month: "short" });
          const month_ = month.charAt(0).toUpperCase() + month.slice(1, 3);
          formattedDate = `${day}/${month_}/${year}`;
        }
        break;
      case "yyyy-mm-dd":
        formattedDate = formatDate;
        break;
      case "yyyy-mm-dT":
      case "yyyy-mm-ddT":
        formattedDate = `${formatDate}T00:00:00`;
        break;
      case "yyyy-mm-ddTZ":
        formattedDate = `${formatDate}T00:00:00Z`;
        break;
      case "long": {
        const weekday = dateJs.toLocaleString(lang || "default", { weekday: "long" });
        const monthLong = dateJs.toLocaleString(lang || "default", { month: "long" });
        if (lang === "es-MX") formattedDate = `${weekday}, ${day} de ${monthLong} de ${year}`;
        else formattedDate = `${weekday}, ${monthLong} ${day}, ${year}`;
        break;
      }
      case "time": {
        const hora = dateJs.toLocaleTimeString(lang || "default", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
        formattedDate = `${formatDate} ${hora}`;
        break;
      }
      default:
        console.error("ERROR createDate: Requiere outputFormat válido.");
        break;
    }
  } catch (error) {
    formattedDate = "";
    console.log("ERROR createDate: ", error);
  }
  return formattedDate;
}

export const DATE_1900 = createDate("yyyy-mm-ddT", 1900, 0, 1);

export const FIRST_DAY_MONTH_DATE = createDate("yyyy-mm-ddT", Number(currentYear()), getCurrentIndexMonth(), 1);

export function getDayOfYear(day: string): string {
  let formatDate = "";
  let dateJs = new Date();
  let lang = getValidLanguage();

  try {
    if (day === "first") {
      dateJs = new Date(new Date().getFullYear(), 0, 1);
    } else if (day === "last") {
      dateJs = new Date(new Date().getFullYear(), 11, 31);
    }

    const day_ = dateJs.toLocaleString(lang || "default", { day: "2-digit" });
    const year = dateJs.toLocaleString(lang || "default", { year: "numeric" });
    let month = dateJs.toLocaleString(lang || "default", { month: "2-digit" });
    formatDate = `${year}-${month}-${day_}T00:00:00`;
  } catch (error) {
    formatDate = "";
    console.log("ERROR getDayOfYear: " + error);
  }
  return formatDate;
}

export function getDayOfMonth(year: number, monthIndex: number): number {
  let days = 0;
  let dateJs = new Date();

  try {
    dateJs = new Date(year, monthIndex + 1, 0);
    days = dateJs.getDate();
  } catch (error) {
    console.log("ERROR getDayOfMonth: " + error);
  }
  return days;
}

export function getDaysBetweenDates(beginDate: Date, endDate: Date): any {
  try {
    return (endDate.valueOf() - beginDate.valueOf()) / (1000 * 3600 * 24);
  } catch {
    return null;
  }
}

export function currentYear(): string {
  const lang = getValidLanguage();
  const langToLocale = lang ?? "default";

  const dateJs = new Date();
  const year = dateJs.toLocaleString(langToLocale, { year: "numeric" });
  return year;
}

export function getDayOfWeek(date: string): any {
  const day = new Date(date).getUTCDay();
  return day;
}

export function getCurrentMonth(date: string): any {
  const month = new Date(date).getMonth();
  return month + 1;
}

export function getCurrentIndexMonth(): number {
  const month = new Date().getMonth();
  return month;
}

export function getYearDate(date: string): any {
  const year = new Date(date).getFullYear();
  return year;
}

export function getDayDate(date: string): any {
  const day = new Date(date).getDate();
  return day;
}

////////////////////////////////////////// reports //////////////////////////////////////////
export function getFieldDescription(fieldDesc: string, start: string, end: string, validateZero: boolean = false): string {
  if (start !== "" && (!validateZero || start !== "0") && (end === "" || (validateZero && end === "0"))) {
    return `${fieldDesc} ${start}`;
  } else if (end !== "" && (validateZero ? end !== "0" : true)) {
    return `${fieldDesc} ${start} - ${end}`;
  } else {
    return "";
  }
}

export function getQryFilter(field: string, start: string, end: string, startIndex: number, like: boolean = false): object {
  let query: string = startIndex > 0 ? " and " : "";
  let qryArray: Array<string> = [];
  let index: number = startIndex;
  let equals = like ? "like" : "=";

  if (start !== "" && end !== "") {
    query += `${field} between @${index} and @${index + 1}`;
    qryArray = [start, end];
  } else if (start !== "" && end === "") {
    query += `${field} ${equals} @${index}`;
    qryArray = [start];
  } else if (start === "" && end !== "") {
    query += `${field} ${equals} @${index}`;
    qryArray = [end];
  }
  return {
    query: query,
    params: qryArray,
  };
}

////////////////////////////////////////// TextBox Function //////////////////////////////////////////
let valueStoredTB = "";

export function maxLengthCheckTB(e: any, numberUnits: number, numberDecimals: number, withFormat: boolean = true) {
  const input = e.event.currentTarget;
  const newValue = input.value.replace(/,/g, "");
  const regex = /^(|0\.?\d*|[1-9]\d*\.?\d*)$/;

  if (valueStoredTB === "") {
    valueStoredTB = input.ariaValueNow;
  }

  if (!regex.test(newValue)) {
    input.value = valueStoredTB;
    e.event.preventDefault();
    return;
  }

  const [integerPart, decimalPart] = newValue.split(".");

  if (integerPart.length > numberUnits || (decimalPart && decimalPart.length > numberDecimals)) {
    input.value = valueStoredTB;
    e.event.preventDefault();
    return;
  }

  let formattedInteger = integerPart;
  if (integerPart.length > 3 && withFormat) {
    formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const formattedValue = decimalPart !== undefined ? `${formattedInteger}.${decimalPart}` : formattedInteger;
  input.value = formattedValue;
  valueStoredTB = formattedValue;
}

export function checkDot(input: number, funct: any) {
  const value = input?.toString().trim() || "";

  if (value.endsWith(".")) {
    const valueFinal = value.slice(0, -1);
    funct(valueFinal);
  }
}
////////////////////////////////////////// NumberBox Function //////////////////////////////////////////
let valueStored = 0;
export function maxLengthCheck(e: any) {
  let newValue = e.event.currentTarget.value;
  let data = newValue.replace(/,/g, "").split(".");

  //Si no hay un valor almacenado se asigna el valor actual
  //Con el fin de que si el nuevo valor es invalido se vuelva a asignar el almacenado
  if (valueStored === 0) {
    valueStored = e.event.currentTarget.ariaValueNow;
  }

  if (e.event.currentTarget.max === "undefined") {
    console.warn("Al utilizar maxLengthCheck se debe asignar el valor de la propiedad max");
    return;
  }

  //Extraccion de numero de unidades y decimales permitidas con el maxValue asignado al NumberBox
  let maxValue = String(e.event.currentTarget.max);
  let numberUnits = 0;
  let numberDecimals = 0;
  if (maxValue.includes(".")) {
    numberUnits = maxValue.split(".")[0].length;
    numberDecimals = maxValue.split(".")[1].length;
  } else {
    numberUnits = maxValue.length;
  }

  //Validacion segun el numero de unidades permitidas
  if (numberUnits < data[0].length) {
    e.event.currentTarget.value = valueStored;
    e.event.preventDefault();
    return;
  }

  //Validacion segun el numero de decimales permitidas
  if (data.length > 1) {
    if (numberDecimals < data[1].length) {
      e.event.currentTarget.value = valueStored;
      e.event.preventDefault();
      return;
    }
  }

  //Almacenamiento de valor nuevo permitido correctamente
  valueStored = newValue;
}

export function getQueryString(url: string, params: any): string {
  if (!params) return url;

  const searchParams = new URLSearchParams();

  Object.keys(params).forEach((key) => {
    searchParams.append(key, params[key]);
  });

  return `${url}?${searchParams.toString()}`;
}

export function cleanPedimento(pedimento: any): number {
  const pedClean = String(pedimento ?? "").replace(/\D/g, "");
  return Number(pedClean);
}

export function getUrlParam(param: string, href: string): string {
  const urlParams = href.split("?")[1];

  if (!urlParams) return "";

  const params = urlParams.split("&");
  let dato = "";

  params.forEach((chunk) => {
    if (chunk.includes(param) && chunk.includes("=")) dato = chunk.split("=")[1];
  });

  return dato;
}

export function formatDecimalNumberBox(value: number, maxNumber: string, tipo: string): string {
  let valor = String(value);
  try {
    if (parseFloat(valor) > parseFloat(maxNumber)) valor = maxNumber;

    let maxEnteros = maxNumber.split(".")[0] || "";
    let maxDecimales = maxNumber.split(".")[1] || "";

    let intVal = valor.split(".")[0];
    let decVal = valor.split(".")[1] || maxDecimales;

    if (intVal.length > maxEnteros.length) intVal = intVal.substring(0, maxEnteros.length);

    if (decVal.length > maxDecimales.length) decVal = "." + decVal.substring(0, maxDecimales.length);
    else decVal = "." + decVal;

    if (tipo === "pesos") return "$" + intVal.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + decVal;
    else if (tipo === "porcentaje") return intVal.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + decVal + "%";
    else return intVal.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + decVal;
  } catch {
    return valor;
  }
}

export function formatDecimalNumberBox2(value: number, maxNumber: string, tipo: string): string {
  let valor = String(value);
  let maximo = String(maxNumber ?? "0.0");

  if (!valor) {
    return "";
  }

  if (valor.includes("..")) {
    valor = valor.replace("..", ".");
  }

  if (maximo.length > valor.length) {
    valor = valor.substring(0, maximo.length);
  }

  try {
    let maxEnteros = maximo.split(".")[0];
    let maxDecimales = maximo.split(".")[1];

    let entero = "";
    let decimal = "";

    if (valor.includes(".")) {
      entero = valor.split(".")[0];
      decimal = valor.split(".")[1];

      if (entero.length > maxEnteros.length) {
        entero = entero.substring(0, maxEnteros.length);
      }

      if (decimal) {
        if (decimal.length > maxDecimales.length) {
          decimal = "." + decimal.substring(0, maxDecimales.length);
        } else {
          decimal = "." + decimal;
        }
      } else {
        decimal = "." + "0".repeat(maxDecimales.length);
      }
    } else {
      entero = valor;

      if (entero.length > maxEnteros.length) {
        entero = entero.substring(0, maxEnteros.length);
      }

      decimal = "." + "0".repeat(maxDecimales.length);
    }

    const regEx = /\B(?=(\d{3})+(?!\d))/g;
    let valorFormateado = "";

    if (tipo === "pesos") {
      valorFormateado = "$" + entero.replace(regEx, ",") + decimal;
    } else if (tipo === "porcentaje") {
      valorFormateado = entero.replace(regEx, ",") + decimal + "%";
    } else {
      valorFormateado = entero.replace(regEx, ",") + decimal;
    }

    return valorFormateado;
  } catch {
    console.log("ERROR formatDecimalNumberBox2");
    return valor;
  }
}

export function formatIntegerNumberBox(value: number, maxLength: number, useComma: boolean, tipo: string): string {
  let valor = String(value);

  try {
    const valorLength = valor.toString().length;
    if (valorLength > maxLength) valor = String(value).substring(0, maxLength);

    const regEx = /\B(?=(\d{3})+(?!\d))/g;

    if (tipo === "pesos") {
      return `$${useComma ? valor.replace(regEx, ",") : valor}`;
    } else if (tipo === "porcentaje") {
      return `${useComma ? valor.replace(regEx, ",") : valor}%`;
    } else return useComma ? valor.replace(regEx, ",") : valor;
  } catch {
    return valor;
  }
}

export function showAdvertencias(title: string, proceso: string, llave: string, parametros: string): void {
  const guid = getUuidv4();

  const warning = {
    proceso: proceso,
    llave: llave,
    title: title,
    parametros: parametros,
  };

  localStorage.setItem(`war_${guid}`, JSON.stringify(warning));
  window.open("./#/Warnings?id=" + guid, "_blank");
}

export function centerTextMessageBox(texto: string): string {
  return `<div style='text-align:center;'>${texto}</div>`;
}

/**
 * Genera número de factura consecutiva
 *
 * @param tfac_inicial - Prefijo para formar el número de factura.
 * @param tfac_num - Consecutivo a utilizar para formar el número de factura.
 * @param mascara - Número de ceros que se anteponen en Consecutivo de la factura.
 */
export function getFacturaMask(tfac_inicial: string, tfac_num: string, mascara: string): string {
  let facturaConMascara = "";
  let mascaraLimpia = mascara.replace("-", "");
  let diferenciaCaracteres = 0;
  tfac_inicial = String(tfac_inicial);
  tfac_num = String(tfac_num);
  mascara = String(mascara);

  if (tfac_num.length === mascaraLimpia.length) {
    facturaConMascara = getStringMask().apply(tfac_num, mascara, { reverse: true });
  } else if (tfac_num.length > mascaraLimpia.length) {
    diferenciaCaracteres = tfac_num.length - mascaraLimpia.length;
    mascara = "0".repeat(diferenciaCaracteres) + mascara;
    facturaConMascara = getStringMask().apply(tfac_num, mascara, { reverse: true });
  } else if (tfac_num.length < mascaraLimpia.length) {
    diferenciaCaracteres = mascaraLimpia.length - tfac_num.length;
    const nuevoNumeroFactura = "0".repeat(diferenciaCaracteres) + tfac_num;
    facturaConMascara = getStringMask().apply(nuevoNumeroFactura, mascara, { reverse: true });
  }

  const facturaFinal = tfac_inicial + facturaConMascara;
  return facturaFinal;
}

export function showLogMovimientos(programa: string, llave: string): void {
  localStorage.setItem("acomm108_programa", programa);
  localStorage.setItem("acomm108_llave", llave);
  window.open("./#/ACOMM108", "_blank");
}

export function crearPedimento15Digitos(pedimento: string): string {
  let pedimentoNuevo = String(pedimento ?? "").replace(/\D/g, "");

  const lengthPedimento = pedimentoNuevo.length;
  const digitosPedimento = 15;

  if (lengthPedimento < 15) {
    const diferenciaCaracteres = digitosPedimento - lengthPedimento;
    pedimentoNuevo = "0".repeat(diferenciaCaracteres) + pedimentoNuevo;
  }

  return pedimentoNuevo;
}

export function getPedimentoCero(): string {
  return "000000000000000";
}

export function allowAccess(isBlocked: boolean, mensaje: string, push: Function): boolean {
  if (isBlocked) {
    notify({ message: mensaje, width: 400, shading: false }, "warning", 4000);
    push("/");
  }

  return !isBlocked;
}

export function allowAccessTab(isBlocked: boolean, mensaje: string, closeTab: Function): boolean {
  if (isBlocked) {
    notify({ message: mensaje, width: 400, shading: false }, "warning", 4000);
    closeTab();
  }

  return !isBlocked;
}

export function setCustomConfirmMessage(texto: string, width: number): string {
  return `<div style='text-align:center;width:${width}px;'>${texto}</div>`;
}

export function getToken(): string {
  const cookieName = getTokenName();
  const token = Cookies.get(cookieName);
  return String(token ?? "");
}

export function isValidJson(json: string): boolean {
  try {
    JSON.parse(json);
    return true;
  } catch (error) {
    return false;
  }
}

export function getDiasTranscurridos(fecha: string): any {
  try {
    const inicio = new Date(fecha);
    const hoy = new Date(currentDate("yyyy-mm-ddTZ"));
    const dias = getDaysBetweenDates(inicio, hoy);
    return dias;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export function generarMensajePorParteGenerados(titulo: string, listaPartes: string): any {
  const mensaje = `
  <div style='text-align:center'>${titulo}</div>
  <br>
  <div style='height:10rem;width:100%;border:1px solid darkgray;overflow:auto;padding:0.25rem;white-space:pre-line;'>${listaPartes}</div>`;

  return mensaje;
}

export function exportGridToExcel(component: any): any {
  const instance = component?.current?.instance ?? component;
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Main sheet");

  const title = instance.option()?.export?.fileName ?? "data";

  exportDataGrid({
    component: instance,
    worksheet: worksheet,
    autoFilterEnabled: true,
  }).then(() => {
    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAsCustom(new Blob([buffer], { type: "application/octet-stream" }), `${title}.xlsx`);
    });
  });
}

export function showNotify(tipo: string, mensaje: string, width: number = 450, shading: boolean = false, time: number = 3500): any {
  notify({ message: mensaje, width: width, shading: shading }, tipo, time);
}

export function getSelectedRow(gridReference: any): any {
  const registros = gridReference.current.instance.getSelectedRowsData();
  if (registros.length === 0) return null;
  return registros[0];
}

export function getSelectedKey(gridReference: any): any {
  const keys = gridReference.current.instance.getSelectedRowKeys();
  if (keys.length === 0) return null;
  return keys[0];
}

export function getAjaxSettingsHeaders(token: any): any {
  const headers = {
    Authorization: `bearer ${token}`,
    "Accept-Language": i18n.language,
  };
  return headers;
}

export function localStructuredClone(object: any): any {
  const clonedObject = JSON.parse(JSON.stringify(object));
  return clonedObject;
}

export function trimAll(object: any): any {
  if (!object) {
    return;
  }

  const result = { ...object };
  const properties = Object.keys(object);

  if (!properties) {
    return;
  }

  properties.forEach((prop) => {
    if (typeof result[prop] === "string") {
      result[prop] = result[prop]?.trim();
    }
  });

  return result;
}

export function datoFinalEsIgualOMayor(datoInicial: string, datoFinal: string): boolean {
  return datoInicial.localeCompare(datoFinal) <= 0;
}

export function isString(value: any): any {
  return typeof value === "string";
}

export function isObject(value: any): any {
  return typeof value === "object";
}

export function isNumber(value: any): any {
  return typeof value === "number";
}

export function getForbiddenMessage(response: any): string {
  const url = response?.config?.url ?? "";
  const baseURL = response?.config?.baseURL ?? "";
  const urlComplente = new URL(`${baseURL}/${url}`);
  const pathName = urlComplente?.pathname ?? "";
  const errorMessage = response?.response?.data ?? "";
  console.error(pathName, ": ", errorMessage);
  return errorMessage;
}

export function getIdComponent(e: any): string {
  let id = "";

  if (e.validator) {
    id = e.validator._$element[0].id;
  } else {
    id = e?.element?.id;
  }

  return id;
}

export function getCurrentLang(): string {
  const lng = localStorage.getItem("i18nextLng") ?? "es-MX";
  return lng;
}

export function isEventKey(e: any, eventName: string = ""): boolean {
  const currentEvent = e?.event?.originalEvent?.key ?? "";
  return currentEvent === eventName;
}

export function showReport(params: any): void {
  const id = getUuidv4();
  const data = JSON.stringify(params);
  const state = { ReportSourceData: data };

  if (data) {
    localStorage.setItem(id, JSON.stringify(state));
  }

  window.open("./#/ReportViewerWindow?rpId=" + id, "_blank");
}

export function getValueOnChange(e: any): string {
  return e.event.target.value;
}

export function showAIntcfg100Consulta({ tabla = "", erp = "" }: { tabla: string; erp: string }): void {
  if (!tabla || !erp) {
    return;
  }

  storeSessionStorageAndOpenTab("AIntcfg100Consulta", { tabla, erp });
}

export function isValidLanguage(lang: any): boolean {
  return ["en-US", "es-MX", "en", "es"].includes(lang);
}

export function getValidLanguage(): string {
  const currentLang = getCurrentLang();

  if (isValidLanguage(currentLang)) {
    return currentLang === "en" ? "en-US" : currentLang === "es" ? "es-MX" : currentLang;
  }

  return "es-MX";
}

export function defaultCallback() {
  return;
}

export function closeManyButtonPanel(manyButtonPanelRef: any) {
  manyButtonPanelRef.current.hide();
}

export function calculateFilterExpressionContains(this: any, filterValue: any) {
  const column = this;
  const filter = "contains";
  let filterExpression = [column.dataField, filter, filterValue];
  return [filterExpression];
}

export function isNullOrUndefined(value: any) {
  return value === null || value === undefined;
}

export function takeAduana(pedimento: any) {
  return String(pedimento).substring(2, 4);
}

export function takePatente(pedimento: any) {
  return String(pedimento).substring(4, 8);
}

export function closeContextMenu(e: any) {
  e?.component?.hide();
}

export function areObjectsDifferent(obj1: any, obj2: any) {
  return JSON.stringify(obj1) !== JSON.stringify(obj2);
}

export function customizeColumnsPedimento(columns: any) {
  for (let col of columns) {
    if (col.format === "pedimento") {
      col.format = formatPedimento;
    }
  }
}

export function customizeColumnsPedimentoEmpty(columns: any) {
  for (let col of columns) {
    if (col.format === "pedimento") {
      col.format = formatPedimentoEmpty;
    }
  }
}

export function getTokenName() {
  const currentPath = window.location.pathname.split("/")[1];
  const cookieName = `token_${currentPath}`;
  return cookieName;
}

/**
 * Almacena objeto en sessionStorage
 *
 * @remarks
 * El objeto recibido se guardará como tipo string. Usa: JSON.stringify().
 *
 * Se generará un uuid, que será la key del sessionStorage y el parámetro "id" de la URL
 *
 * @param url - URL del tab (url definida en Routers)
 * @param obj - Data que se almacenará en sessionStorage
 */
export function storeSessionStorageAndOpenTab(url: string, obj: object): void {
  const guid = getUuidv4();

  try {
    const data = JSON.stringify(obj);
    sessionStorage.setItem(guid, data);
  } catch (error) {
    console.error("Error al almancenar datos en sessionStorage:", error);
    return;
  }

  const fullUrl = `./#/${url}?id=${guid}`;
  window.open(fullUrl, "_blank");
}

/**
 * Obtiene data del sessionStorage según el parámtro "id" de la URL
 *
 * @remarks
 * El valor que se lee en sessionStorage se espera que sea un string, ya que se usa JSON.parse para poder devolver un objeto.
 *
 * @param url - URL. Por default es: window.location.href
 */
export function getDataSessionStorageByUrlId(url: string = window.location.href): any {
  const guid = getUrlParam("id", url);

  if (!guid) {
    console.warn("No se encontró el parámetro 'id' en la URL.");
    return;
  }

  const datosSessionStorage = sessionStorage.getItem(guid);

  if (!datosSessionStorage) {
    console.warn(`No se encontraron datos en sessionStorage para el GUID: ${guid}`);
    return;
  }

  try {
    const data = JSON.parse(datosSessionStorage);
    sessionStorage.removeItem(guid);
    return data;
  } catch (error) {
    console.error("Error al parsear los datos almacenados en sessionStorage:", error);
    return;
  }
}

/**
 * Abre un nuevo tab del navegador
 *
 * @param url - La URL que se va a abriy
 */
export const openBrowserTab = (url: string) => {
  window.open(`./#/${url}`, "_blank");
};

export const getAccessKeyByUrlA24 = (title: string, fromAnexo24: any) => {
  return fromAnexo24 ? `${title}A24` : title;
};

export function getCustomFilterColumnsProps(field: string): any {
  const isNumeric = ["ph_pedimento", "imh_pedimento", "exh_pedimento"].includes(field);

  if (isNumeric) {
    const props = { filterOperations: defaultFilterOperationsNumeric, selectedFilterOperation: "" };
    props.filterOperations.push("contains");
    props.selectedFilterOperation = "contains";
    return props;
  } else {
    return {};
  }
}

export function stringifyEmpty(values: string): boolean {
  return values === "{}";
}

export function isExcelFile(fileName: string = ""): boolean {
  const ext = /[.]/.exec(fileName) ? /[^.]+$/.exec(fileName)?.[0] : undefined;
  return ["xlsx", "xls"].includes(ext ?? "");
}

export function isObjectEmpty(objeto: object): boolean {
  return Object.getOwnPropertyNames(objeto).length === 0;
}

export function wasTriggeredByCancelButton(e: any): boolean {
  return e?.event?.originalEvent?.relatedTarget?.id === "cancelButton";
}

export const getAboutPropsParam = (props: any) => {
  const param = props?.location?.aboutProps?.param;
  return param;
};

export const repaintComponent = (ref: any) => {
  if (ref.current) {
    ref.current?.instance.repaint();
  }
};
